/* -------------------------------------------------------------------------- */
/*                                 Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";

// Components
import App from './App.tsx';

// Styles
import '@/styles/global.css';

// Configs
import { env } from '@/configs/env.config';

// i18n
import '@/i18n/i18n.ts';

/* -------------------------------------------------------------------------- */
/*                                Entry Point                                 */
/* -------------------------------------------------------------------------- */
// Note: Clarity sera initialisé via le hook useCookieConsent pour gérer le consentement
Sentry.init({
  dsn: env.physiomKine.sentry.dsn,
  integrations: [
    Sentry.browserTracingIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
createRoot(document.getElementById('root')!).render(
  env.nodeEnv === 'development' ? (
    <StrictMode>
      <App />
    </StrictMode>
  ) : (
    <App />
  )
);
